import Select from "react-select";
import { isMobile } from "../common";
import { useMemo } from "react";
type Option = {
  value: string | number;
  label: string;
  isFixed?: boolean;
};

export const searchStyle = {
  valueContainer: (base: any) => ({
    ...base,
    maxHeight: 40,
    fontSize: isMobile ? 10 : 14,
    overflowY: "auto",
  }),
  multiValue: (base: any, state: { data: { isFixed: any } }) => {
    return state.data.isFixed ? { ...base, backgroundColor: "gray" } : base;
  },
  multiValueLabel: (base: any, state: { data: { isFixed: any } }) => {
    return state.data.isFixed
      ? { ...base, fontWeight: "bold", color: "white", paddingRight: 6 }
      : base;
  },
  menuList: (base: any) => ({
    ...base,
    maxHeight: 350,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  multiValueRemove: (
    base: any,
    state: {
      data: {
        value: any;
        isFixed: any;
      };
    }
  ) => {
    return state.data.isFixed ? { ...base, display: "none" } : base;
  },
};

export function SearchBox({
  options,
  selectedOptions,
  onChange,
  placeholder,
  isMany,
  menuMaxHeight, // NEW optional prop
}: {
  options: Option[];
  selectedOptions: Option[];
  onChange: (selected: Option[]) => void;
  placeholder: string;
  isMany?: boolean;
  menuMaxHeight?: number; // NEW
}) {
  const styles = useMemo(() => {
    if (menuMaxHeight == null) return searchStyle;
    return {
      ...searchStyle,
      menuList: (base: any) => ({
        ...base,
        maxHeight: menuMaxHeight,
        paddingTop: 0,
        paddingBottom: 0,
      }),
    };
  }, [menuMaxHeight]);

  return (
    <Select
      className="text-sm text-gray-800 "
      placeholder={placeholder}
      value={selectedOptions.map((option) => ({
        ...option,
        isFixed: false,
      }))}
      isMulti={isMany}
      onChange={onChange as any}
      styles={styles}
      options={options as any}
    />
  );
}

type Props = {
  start: { year: number; month: number };
  end: { year: number; month: number };
  selectedOptions: Option[];
  onChange: (selected: Option[]) => void;
  isMany?: boolean;
  placeholder?: string;
  customRanges?: Option[]; // Optional custom date ranges
};

export const generateMonthRanges = (
  start: { year: number; month: number },
  end: { year: number; month: number }
) => {
  const result: Option[] = [];
  let currentYear = start.year;
  let currentMonth = start.month;

  while (
    currentYear < end.year ||
    (currentYear === end.year && currentMonth <= end.month)
  ) {
    const startDate = new Date(currentYear, currentMonth - 1, 1);
    const endDate = new Date(currentYear, currentMonth, 0);

    const formattedStart = startDate.toISOString().split("T")[0];
    const formattedEnd = endDate.toISOString().split("T")[0];
    const monthLabel = startDate
      .toLocaleString("default", { month: "short" })
      .toUpperCase();
    const yearLabel = String(currentYear).slice(-2);

    result.push({
      value: `${formattedStart},${formattedEnd}`,
      label: `${monthLabel}-${yearLabel}`,
    });

    if (currentMonth === 12) {
      currentMonth = 1;
      currentYear++;
    } else {
      currentMonth++;
    }
  }
  return result;
};

const SelectOption: React.FC<Props> = ({
  start,
  end,
  selectedOptions,
  onChange,
  isMany = false,
  placeholder = "Select Date Range",
  customRanges = [],
}) => {
  const options = generateMonthRanges(start, end).concat(customRanges);
  return (
    <SearchBox
      options={options}
      selectedOptions={selectedOptions}
      onChange={onChange}
      placeholder={placeholder}
      isMany={isMany}
    />
  );
};

export default SelectOption;
